import { useAppDispatch } from "redux/app/hooks";
import { Route as ROUTES } from "utils";
import { useGetSelfPointsQuery } from "api";
import { authActions } from "redux/features";
import { ThunkDispatch, AnyAction, Dispatch } from "@reduxjs/toolkit";

export const ProtectedRoute = (ProtectedComponent: React.ComponentType<any> | React.LazyExoticComponent<React.ComponentType<any>>) => {
  const handleLogout = (dispatch: ThunkDispatch<any, null, AnyAction> & ThunkDispatch<any, undefined, AnyAction> & Dispatch<any>) => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("persist:gacha");
    localStorage.clear();
    sessionStorage.clear();
    dispatch(authActions.logout());
    dispatch(authActions.reset());
    dispatch(authActions.loginFailed());
  };

  return (props: any) => {
    if (typeof window !== "undefined") {
      const isLoggedIn = Boolean(localStorage.getItem("isLoggedIn"));
      const { isError } = useGetSelfPointsQuery({});
      const dispatch = useAppDispatch();

      if (isError || !isLoggedIn) {
        handleLogout(dispatch);
        window.location.href = ROUTES.USER_LOGIN
        return null;
      }

      return <ProtectedComponent {...props} />;
    }

    return null;
  };
};